import React from "react";
import { Link } from "react-router-dom";
import Icon from "../icons/Icon";

// O último item é sempre a página atual: marcá-lo com aria-current é o que
// distingue "onde estou" de "para onde posso voltar".
function Breadcrumb({ items }) {
  return (
    <nav className="breadcrumb" aria-label="Trilha de navegação">
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 && <Icon name="chevron-right" />}
          {item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : (
            <span aria-current="page">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}

export default Breadcrumb;
